<template>
  <b-modal
    v-if="tracks != null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <h1>{{ Translations.sections.tracks.edition.label }}</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTracks">Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <form class="form-container search" @submit.prevent="searchDelay(0)">
          <input
            type="text"
            v-focus
            maxlength="100"
            placeholder="Search Label"
            v-model="searchData.searchTerm"
          />
          <Button :empty="true" :noBorder="true" type="submit" @click.prevent="searchDelay(0)">
            <i class="fas fa-search"></i>
          </Button>
        </form>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingLanguages"></WaitingBlock>
          <template
            v-else-if="searchResult!=null && searchResult.dataItem !=null && searchResult.dataItem.items !=null && searchResult.dataItem.items.length > 0"
          >

            <div v-for="label in labels"
              :class="['label-container', { 'selected' : isSelected(label) }]"
              @click.prevent="toggleLabel(label)"
            >
              <i :class="['far', isSelected(label) ?'fa-check-square': 'fa-square']"></i>
              <span class="name">
                <strong>{{label.name}}</strong>
              </span>
            </div>
          <div class="no-result-container">
            <header v-if="!noModalUpdate">
              <strong>Do you want to create a new label ?</strong>
            </header>

            <div class="form-container creation" v-if="modalState.hasSearchProcessed && !noModalUpdate">
              <label class="creation-title">Create a new label</label>
              <div class="creation-form">
                <input type="text" v-model="creationData.name" placeholder="Add a new label" />
                <Button :empty="true" :noBorder="true" @click.prevent="createLabel()" :disabled="modalState.isCreatingLabel"><i class="fas fa-plus"></i></Button>
              </div>
            </div>
          </div>
          </template>
          <div v-else class="no-result-container">
            <header>
              <strong>No artist matching your search criteria</strong>
            </header>
            <div class="form-container creation" v-if="modalState.hasSearchProcessed && !noModalUpdate">
              <label class="creation-title">Create a new label</label>
              <div class="creation-form">
                <input type="text" v-model="creationData.name" placeholder="Add a new label" />
                <Button :empty="true" :noBorder="true" @click.prevent="createLabel()" :disabled="modalState.isCreatingLabel"><i class="fas fa-plus"></i></Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedLabel">
<!--          <header>Selected labels :</header>-->
          <section>
<!--            <div :class="['badge', 'label-badge',{'selected' : selectedLabel !=null}]">-->
<!--              <span class="name">{{selectedLabel.name ? selectedLabel.name :  selectedLabel[0].name}}</span>-->
<!--              <span class="selector">-->
<!--&lt;!&ndash;                <i class="fas fa-trash" @click.prevent="toggleLabel(selectedLabel)"></i>&ndash;&gt;-->
<!--              </span>-->
<!--            </div>-->
          </section>
        </template>
      </div>
<!--      <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</Button>-->
<!--            <Button :empty="false" class="validate" @click.prevent="updateTracks">-->
<!--                Update {{tracks.length}} track(s)-->
<!--      </Button>-->
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorLabels",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    labels(){
      let allLabels = ((this.searchResult || {}).dataItem ||{}).items || [];
      allLabels.sort(function (a, b){
        let mm = /MM /;
        // Storever First
        switch(true){
          case (a.name.localeCompare("storever")==0) : return -1;
          case (b.name.localeCompare("storever")==0) : return 1;
          case mm.test(a.name) && mm.test(b.name) : return b.name.localeCompare(b.name);
          case mm.test(a.name) : return -1;
          case mm.test(b.name) : return 1;
          default : return a.name.localeCompare(b.name)
        }
        return 0;
      });
      return allLabels;
    }
  },
  mounted() {
    this.search();
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null,
    noModalUpdate: true,
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingLanguages: false,
        isCreatingLabel: false,
        delayedSearch: null
      },
      creationResult: null,
      creationData: {
        name: "",
        categoryId: 1
      },
      tracks: [],
      selectedLabel: null,
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      }
    };
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  methods: {
    createLabel() {
      this.modalState.isCreatingArtist = true;
      if(this.creationData.name) {
        HTTP.post(Apis.label.create, this.creationData)
            .then(this.createEnd)
            .catch(this.createError)
            .then(this.createCompleted)
      }

    },
    createEnd(response) {
      this.creationResult = response.data;
      if (this.creationResult.dataItem != null) {
        this.searchData.searchTerm = this.creationResult.dataItem.name,
            this.toggleLabel(this.creationResult.dataItem);
        this.search();
        this.modalState.isCreationActive = false;
        this.creationData.name = "";
      }
    },
    createError(error) {
      this.creationResult = error.response.data;
    },
    createCompleted(response) { this.modalState.isCreatingArtist = false; },
    normalizeSearchTerm(str) {
      return (str || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    show() {
      this.$refs.modal.show();
      if (this.$refs.inputSearch) {
        this.$refs.inputSearch.focus();
      }
    },
    edit(labels) {
      this.selectedLabel = labels;
      this.show();
    },
    editForTracks(tracks) {
      this.tracks = tracks;
      this.selectedLabel = null;
      if (this.tracks != null && this.tracks.length > 0) {
        this.selectedLabel = tracks[0].label;
      }

      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingLanguages = true;
      this.creationData.name = this.searchData.searchTerm;
      try {
        HTTP.get(Apis.parameters.labels, {
          params: this.searchData
        })
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data;
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingLanguages = false;
      this.modalState.hasSearchProcessed = true;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
      var result = null;

      if (this.noModalEdit) {
        this.cancelModal();
        this.$emit("newValue", "label", this.selectedLabel);
        return;
      }

      try {
        var data = {
          stationUid: this.stationUid,
          trackUids: this.trackUids,
          value: this.selectedLabel[0].id
        };
        result = await HTTP.post(Apis.library.tracks.update.label, data);
        if (result.data.dataItem != null) {
          this.tracks.forEach(function(track) {
            if (track == null) return;
            var updatedTrack = result.data.dataItem[track.uid];
            if (updatedTrack === undefined) return;
            track.label = updatedTrack.label;
            track.warnings = updatedTrack.warnings;
            track.isFilled = updatedTrack.isFilled;
          });
          this.cancelModal();
        }
      } catch (error) {
        //alert(error);O
        result = error.response.data;
      }
      if (result != null && result.errors && result.errors.length === 0) {
        this.cancelModal();
      } else {
        // an error occured : show it
      }
    },
    toggleLabel(label) {
      if (this.multiselect) {
        this.toggleLabels(label);
        return;
      }

      if (label === null || this.selectedLabel === null || this.selectedLabel === undefined) {
        this.selectedLabel = [label];
        return;
      }

      if (label.id === this.selectedLabel.id) {
        this.selectedLabel = [];
      } else {
        console.log('selected: ', [label]);
        this.selectedLabel = [label];
      }
    },

    toggleLabels(label) {

      if (!Array.isArray(this.selectedLabel)) {
        this.selectedLabel = [];
      }
      
      const isAlreadySet = this.selectedLabel.some(e => e.id === label.id);
      if(!isAlreadySet){
        this.selectedLabel.push(label);
      } else {
        const AllLabelExceptCurrent = this.selectedLabel.filter(e => e.id !== label.id);
        this.selectedLabel = AllLabelExceptCurrent === undefined ? [] : AllLabelExceptCurrent
      }
    },
    // Helpers
    isSelected(label) {
      if (!Array.isArray(this.selectedLabel)) {
        return this.selectedLabel && this.selectedLabel.id === label.id;
      }

      const isSelected = this.selectedLabel.filter(l => l.id === label.id);

      return isSelected.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.label-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  cursor: pointer;
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
.creation {
  display: block !important;

  &-title {
    display: block;
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
  }

  &-form {
    display: flex;
  }
}
.form-container {
  padding: 10px 25px;
  background: white;
}
</style>
